var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIngredient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 16C13.9107 16 16 13.9107 16 11.3333C16 8.756 13.9107 6.66667 11.3333 6.66667C8.756 6.66667 6.66667 8.756 6.66667 11.3333C6.66667 13.9107 8.756 16 11.3333 16ZM11.3333 15.3333C13.5425 15.3333 15.3333 13.5425 15.3333 11.3333C15.3333 9.12419 13.5425 7.33333 11.3333 7.33333C9.12419 7.33333 7.33333 9.12419 7.33333 11.3333C7.33333 13.5425 9.12419 15.3333 11.3333 15.3333Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 0L3.33333 0V1.33333H4V4.66667L0.453776 10.1221C0.160563 10.474 0 10.9175 0 11.3755C0 12.4568 0.876546 13.3333 1.95785 13.3333H7.86846C7.52812 12.745 7.33333 12.0619 7.33333 11.3333C7.33333 10.3089 7.71847 9.37434 8.35186 8.66667H3.11112L5.33333 5.16667V1.33333H6.66667V5.16667L8.68093 8.33915C9.03758 8.02298 9.45113 7.76955 9.90427 7.59617L8 4.66667V1.33333H8.66667V0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 10.6667H14V12H8.66667V10.6667Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.66667H12V14H10.6667V8.66667Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIngredient);
export default __webpack_public_path__ + "static/media/AddIngredient.c690ceb8f4be7dcc7c4ea656fda8bb49.svg";
export { ForwardRef as ReactComponent };